module.exports = __webpack_public_path__ + "static/media/default-product.3a22fd2e.jpeg";